import { z } from 'zod';

// PMN (Properties, Metrics, Narrative) module schemas

export const PropertyPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  property_type: z.string().optional(),
  value: z.any(),
  source: z.string().optional(),
  source_raw_data_id: z.string().uuid().optional(),
  tags: z.array(z.string()).optional(),
  custom_fields: z.record(z.any()).optional(),
});

export const MetricPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  metric_type: z.string().optional(),
  value: z.number(),
  unit: z.string().optional(),
  period: z.string().optional(), // e.g., "2024-Q4"
  currency: z.string().length(3).optional(),
  source: z.string().optional(),
  source_raw_data_id: z.string().uuid().optional(),
  tags: z.array(z.string()).optional(),
  custom_fields: z.record(z.any()).optional(),
});

export const NarrativePropsSchema = z.object({
  content: z.string().min(1, 'Content is required'),
  narrative_type: z.string().optional(),
  confidence: z.number().min(0).max(1).optional(),
  source: z.string().optional(),
  source_raw_data_id: z.string().uuid().optional(),
  narrative_date: z.string().datetime().optional(),
  tags: z.array(z.string()).optional(),
  custom_fields: z.record(z.any()).optional(),
});

export type PropertyProps = z.infer<typeof PropertyPropsSchema>;
export type MetricProps = z.infer<typeof MetricPropsSchema>;
export type NarrativeProps = z.infer<typeof NarrativePropsSchema>;
